// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"a456ee16","359":"6eba086d","476":"80f2f5ac","639":"26eafba1","681":"e4bc8ed3"}[chunkId] + ".chunk.js";
};